export interface ReviewProgress {
  lastId: string | null;
  seenIds: string[];
  updatedAt: string | null;
}
export const emptyProgress = (): ReviewProgress => ({ lastId: null, seenIds: [], updatedAt: null });
export function progressKey(userId: string, tenantId: string) {
  return `armard:durcharbeiten:v1:${encodeURIComponent(userId)}:${encodeURIComponent(tenantId)}`;
}
export function readProgress(key?: string): ReviewProgress {
  if (!key) return emptyProgress();
  try {
    const value = JSON.parse(localStorage.getItem(key) ?? 'null');
    if (!value || !Array.isArray(value.seenIds)) return emptyProgress();
    return {
      lastId: typeof value.lastId === 'string' ? value.lastId : null,
      seenIds: [...new Set<string>(value.seenIds.filter((id: unknown) => typeof id === 'string'))],
      updatedAt: typeof value.updatedAt === 'string' ? value.updatedAt : null,
    };
  } catch {
    return emptyProgress();
  }
}
export function writeProgress(key: string | undefined, progress: ReviewProgress): boolean {
  if (!key) return false;
  try {
    localStorage.setItem(key, JSON.stringify(progress));
    return true;
  } catch {
    return false;
  }
}
export function recordViewed(progress: ReviewProgress, id: string): ReviewProgress {
  return {
    lastId: id,
    seenIds: [...new Set([...progress.seenIds, id])],
    updatedAt: new Date().toISOString(),
  };
}
